const projects = {
  'glen_iris': {
    id: 'glen_iris',
    title: 'Glen Iris House',
    subtitle: 'Residential',
    heroImage: '/images/520pro.png',
    overview: 'Luxury elevator interior, premium design, elegant finishes, sophisticated lighting',
    details: {
      type: 'New Build',
      location: 'Glen Iris',
      floor: '2',
      duration: '2 months',
      completed: '2025',
    },
    features: [
      {
        icon: 'fa-water',
        title: 'Coastal Design',
        description: 'Modern architecture that maximizes sea views with floor-to-ceiling windows and indoor-outdoor flow optimized for the waterfront location.'
      },
      {
        icon: 'fa-gem',
        title: 'Premium Materials',
        description: 'High-end finishes including natural stone, hardwood flooring, and marine-grade materials selected for durability in the coastal environment.'
      },
      {
        icon: 'fa-house-signal',
        title: 'Smart Integration',
        description: 'Advanced home automation systems controlling lighting, climate, and security, with seamless integration for modern living.'
      },
      {
        icon: 'fa-sun-plant-wilt',
        title: 'Outdoor Living',
        description: 'Expansive deck areas and landscaped gardens designed for entertaining and enjoying the coastal lifestyle.'
      },
      {
        icon: 'fa-lightbulb',
        title: 'Natural Light',
        description: 'Strategic window placement and open-plan design to maximize natural light and capture stunning bay views throughout the day.'
      },
      {
        icon: 'fa-archive',
        title: 'Custom Storage',
        description: 'Bespoke cabinetry and storage solutions throughout, maximizing space while maintaining clean, minimalist aesthetics.'
      }
    ],
    testimonials: [
      {
        quote: 'R&B Projects transformed our waterfront property into a stunning modern home. Their attention to detail and commitment to quality is evident in every aspect of the renovation. The team\'s expertise in working with coastal properties made the entire process smooth and worry-free.',
        name: 'James & Sarah Thompson'
      },
      {
        quote: 'The level of craftsmanship and professionalism shown by the R&B team was exceptional. They understood our vision perfectly and delivered a home that exceeds our expectations in both design and functionality.',
        name: 'David & Emma Wilson'
      },
      {
        quote: 'Working with R&B Projects was a fantastic experience. Their innovative solutions and attention to detail have created a home that perfectly balances luxury with practical living. We couldn\'t be happier with the result.',
        name: 'Michael & Lisa Anderson'
      }
    ],
    relatedProjects: ['balwyn', 'brighton']
  },
  'balwyn': {
    id: 'balwyn',
    title: 'Balwyn Project',
    subtitle: 'Residential',
    heroImage: '/images/projects/8.jpg',
    overview: 'Modern elevators, residential architecture, contemporary design',
    details: {
      type: 'New Build',
      location: 'Balwyn',
      floor: '3',
      duration: '3 months',
      completed: '2024',
    },
    features: [
      {
        icon: 'fa-tree',
        title: 'Native Landscaping',
        description: 'Extensive use of native plants and trees to blend the property with its natural environment.'
      },
      {
        icon: 'fa-solar-panel',
        title: 'Sustainable Design',
        description: 'Solar panels and rainwater harvesting systems integrated into the roof design.'
      },
      {
        icon: 'fa-temperature-half',
        title: 'Energy Efficient',
        description: 'Passive solar design and high insulation values for year-round comfort.'
      },
      {
        icon: 'fa-palette',
        title: 'Modern Aesthetics',
        description: 'Clean lines and contemporary materials create a timeless architectural style.'
      },
      {
        icon: 'fa-door-open',
        title: 'Indoor-Outdoor Flow',
        description: 'Large sliding doors and covered outdoor areas extend living space outside.'
      },
      {
        icon: 'fa-paint-roller',
        title: 'Quality Finishes',
        description: 'Premium interior finishes including Italian marble and European oak flooring.'
      }
    ],
    testimonials: [
      {
        quote: 'The team delivered exactly what we envisioned. Our new home is more than we ever imagined.',
        name: 'Robert & Jenny Brown'
      },
      {
        quote: 'Professional, efficient, and truly skilled craftsmen. We love our new home.',
        name: 'Mark & Tina Davis'
      }
    ],
    relatedProjects: ['glen_iris', 'brighton']
  },
  'brighton': {
    id: 'brighton',
    title: 'Brighton',
    subtitle: 'Residential',
    heroImage: '/images/projects/9.png',
    overview: 'Modern elevator system, luxury architecture',
    details: {
      type: 'New Build',
      location: 'Brighton, Melbourne',
      floor: '2',
      duration: '3 months',
      completed: '2025',
    },
    features: [
      {
        icon: 'fa-city',
        title: 'Urban Location',
        description: 'Clever design maximizes the potential of the urban site while maintaining privacy.'
      },
      {
        icon: 'fa-couch',
        title: 'Open Plan Living',
        description: 'Spacious open-plan areas create a sense of flow and connectivity throughout the home.'
      },
      {
        icon: 'fa-kitchen-set',
        title: 'Designer Kitchen',
        description: 'Custom kitchen with premium appliances and bespoke cabinetry.'
      },
      {
        icon: 'fa-bath',
        title: 'Spa Bathroom',
        description: 'Luxurious bathroom featuring spa bath and frameless glass showers.'
      },
      {
        icon: 'fa-car',
        title: 'Double Garage',
        description: 'Secure double garage with workshop space and storage.'
      },
      {
        icon: 'fa-fence',
        title: 'Private Garden',
        description: 'Landscaped gardens with automated irrigation and outdoor entertainment area.'
      }
    ],
    testimonials: [
      {
        quote: 'Our Hobsonville home has been completely transformed. The attention to detail is remarkable.',
        name: 'Peter & Mary Wilson'
      }
    ],
    relatedProjects: ['glen_iris', 'balwyn']
  }
};

export const getProject = (projectId) => {
  return projects[projectId] || null;
};

export const getAllProjects = () => {
  return Object.values(projects);
};

export const getProjectIds = () => {
  return Object.keys(projects);
};

export default projects;
